import { SET_MENU_HEADER } from "./actionTypes"

export const setMenuHeader = data => ({
  type: SET_MENU_HEADER,
  payload: data,
})
